export function formatDate(dateLike?: string | null): string {
  if (!dateLike) {
    return '—'
  }

  const date = new Date(dateLike)
  if (Number.isNaN(date.getTime())) {
    return '—'
  }

  return new Intl.DateTimeFormat('ru-RU', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date)
}
